import { useCallback, useEffect, useReducer, useRef } from 'react';
function reducer(state, action) {
    switch (action.type) {
        case 'prev':
            return state - 1;
        case 'next':
            return state + 1;
        default:
            throw new Error();
    }
}
export function useRovingIndex() {
    const [activeIndex, dispatch] = useReducer(reducer, 0);
    const initialized = useRef(false);
    const targets = useRef([]);
    // collects all targets during rendering
    const getTargetRef = useCallback((ref) => {
        if (targets.current.includes(ref))
            return;
        targets.current.push(ref);
    }, []);
    const getTargetProps = useCallback((index) => ({
        ref: getTargetRef,
        tabIndex: activeIndex === index ? 0 : -1,
    }), [activeIndex, getTargetRef]);
    const focusPrevItem = useCallback(() => {
        // clamp to 0 and above only
        if (activeIndex - 1 >= 0) {
            dispatch({ type: 'prev' });
        }
    }, [activeIndex]);
    const focusNextItem = useCallback(() => {
        // clamp navigation to target bounds
        if (activeIndex + 1 < targets.current.length) {
            dispatch({ type: 'next' });
        }
    }, [activeIndex]);
    // when container or children get focus
    const onFocus = useCallback(() => {
        var _a;
        (_a = targets.current[activeIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    }, [activeIndex]);
    // watch for arrow keys
    const onKeyDown = useCallback((e) => {
        switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                focusNextItem();
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                focusPrevItem();
                break;
        }
    }, [focusPrevItem, focusNextItem]);
    // watch for new active item and focus it
    useEffect(() => {
        var _a;
        if (initialized.current) {
            (_a = targets.current[activeIndex]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            initialized.current = true;
        }
    }, [activeIndex]);
    return {
        activeIndex,
        roverProps: { tabIndex: -1, onFocus, onKeyDown },
        getTargetProps,
    };
}
//# sourceMappingURL=index.js.map